/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ico-delete': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M14 14c0 .55-.45 1-1 1s-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4zM8 2.328C8 2.173 8.214 2 8.5 2h3c.286 0 .5.173.5.328V4H8V2.328zM8 14c0 .55-.45 1-1 1s-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4zM19 4h-5V2.328C14 1.044 12.879 0 11.5 0h-3C7.121 0 6 1.044 6 2.328V4H1c-.55 0-1 .45-1 1s.45 1 1 1h1v11c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3V6h1c.55 0 1-.45 1-1s-.45-1-1-1z" _fill="#566473"/>'
  }
})
